import React, { FC, useCallback, useEffect, useState } from "react";
import { AdUploadFiles } from "../AdUploadFiles";
import { Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getAgencyQuotesFormDataAction,
  getFilesByStageAction,
  getNoticeEmailDataAction,
  sendEmailAction,
  startRequestLoadingAction,
} from "../../../../store/actions/raiseAdRequest";
import { useParams } from "react-router-dom";
import { RaiseAdRequestState } from "../../../../store/types/raiseAdRequest";
import { openToast } from "../../../../Toasts";
import {
  canPerformAction,
  handleUploadNoticeFiles,
  StepKeysName,
  StepNames,
} from "../../../RaiseNoticeAdRequest/utils";
import EmailForm from "../EmailForm";
// import { AdUploadFiles } from "../AdUploadFiles";

const permittedRoles = ["admin","product-admin"];
export const FinalMarketingForm: FC = () => {
  const dispatch = useDispatch();

  const {
    quoteDetailsFormData,
    finalMarketFile,
    finalMarketEmailContent,
    userRole,
    lastStepName,
    quoationApprovalFormData,
  } = useSelector(
    (state: { raiseAdRequest: RaiseAdRequestState }) => state.raiseAdRequest
  );
  const [form] = Form.useForm();

  const isStepAccessible = canPerformAction(
    userRole,
    permittedRoles,
    StepNames[4],
    lastStepName,
    quoationApprovalFormData.trashed_at
  );

  const { selectedProductId, requestId } = useParams<{
    selectedProductId: string;
    requestId: string;
  }>();
  const [fileList, setFileList] = useState<any[]>(finalMarketFile);
  const [isFormValuesChanged, setIsFormValuesChanged] = useState<boolean>(
    false
  );
  useEffect(() => {
    dispatch(getAgencyQuotesFormDataAction(requestId));

    dispatch(
      getFilesByStageAction({
        stage: "Final Market go Live",
        request_id: requestId,
      })
    );

    dispatch(getNoticeEmailDataAction({ requestId, stage: 5 }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isStepAccessible && !!userRole) {
      openToast("info", "You only have view access to this information.");
    }
  }, [isStepAccessible, userRole]);

  useEffect(() => {
    if (finalMarketEmailContent) {
      form.setFieldsValue({
        emailContent: {
          ...finalMarketEmailContent,
          to:
            finalMarketEmailContent?.to &&
            finalMarketEmailContent.to.trim() !== ""
              ? finalMarketEmailContent.to
              : quoationApprovalFormData?.emailContent?.to,
          cc:
            finalMarketEmailContent?.to &&
            finalMarketEmailContent.to.trim() !== ""
              ? finalMarketEmailContent.cc
              : quoationApprovalFormData?.emailContent?.cc,
        },
      });
    }
  }, [finalMarketEmailContent, form, quoationApprovalFormData]);

  useEffect(() => {
    setFileList(finalMarketFile);
  }, [finalMarketFile]);

  const handleSubmitUploadFile = useCallback(
    (values: any) => {
      if (!fileList.length) {
        openToast("error", "Please upload pdf file");
        return;
      }
      dispatch(startRequestLoadingAction());
      if (!!finalMarketFile?.length) {
        dispatch(
          sendEmailAction({
            formData: values,
            template_id: "41412186",
            stage: "5",
            s3_urls: [finalMarketFile[0]?.file_url],
          })
        );
      }
      handleUploadNoticeFiles(
        fileList,
        dispatch,
        requestId,
        "Upload Proof",
        "Final Market go Live",
        StepKeysName.UploadProof,
        selectedProductId,
        true,
        values,
        "41412186",
        "5"
      );
    },
    [dispatch, fileList, finalMarketFile, requestId, selectedProductId]
  );

  return (
    <>
      <div className="layout-wrapper">
        {/* Scrollable Form */}
        <div className="layout-wrapper__body">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              marginTop: "2rem",
            }}
          >
            <div
              style={{
                color: "#000",
                fontSize: "1.8rem",
                fontWeight: 500,
              }}
            >
              Upload Purchase Order
            </div>

            <div
              style={{ fontSize: "1.4rem", fontWeight: 500, color: "#556179" }}
            >
              Please upload the final PO before proceeding with ad release. File
              needs to be less than 10MB.
            </div>

            <AdUploadFiles
              accept=".pdf"
              fileList={fileList}
              setFileList={setFileList}
              currentStage={"Final Market go Live"}
              isUesrPermitted={isStepAccessible}
            />
          </div>
          <div
            style={{
              margin: "2rem 0",
              display: "flex",
              gap: "1rem",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                fontSize: "1.6rem",
                fontWeight: 600,
                color: "#394455",
              }}
            >
              Send PO To Agency
            </div>
            <div
              style={{
                fontSize: "1.4rem",
                fontWeight: 400,
                marginBottom: "1rem",
              }}
            >
              PO attached above will be sent through the email
            </div>

            <Form
              form={form}
              className="custom-form"
              onFinish={handleSubmitUploadFile}
              onValuesChange={() => setIsFormValuesChanged(true)}
            >
              <EmailForm
                form={form}
                fixedBody={finalMarketEmailContent?.fixedBody}
                footerMessage={finalMarketEmailContent?.footerMessage}
                subject={finalMarketEmailContent?.subject}
                isUserPermitted={isStepAccessible}
              />
            </Form>
          </div>
        </div>
        {!!isStepAccessible ? (
          <div className="layout-wrapper__footer">
            <button
              className="btn btn--purple"
              disabled={!fileList.length}
              onClick={() => form.submit()}
            >
              Next
            </button>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};
